
import React, { useEffect } from 'react';
import AOS from 'aos';
import page_json from './config/config.json';
import { Helmet } from 'react-helmet';
import ContactUsButton from './ContactUsButton';
import HeroComponent from './HeroComponent';
import SuccessStoriesList from './SuccessStoriesList';
import config from '../config';

const textDataUrl = `${page_json.page_jsons.Stack}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

function Stack() {
	useEffect(() => {
		AOS.init(); // Initialize AOS
	}, []);

	return (
		<div data-aos="fade-up" className='fullstackpage'>
			<Helmet>
                <meta name="description" content="Comprehensive Full-stack Services for your Enterprise" />
                <title>Full Stack Development | Technologies | Engineersmind</title>
            </Helmet>

			<HeroComponent
      bgImageMobile={textData.layer1.mobilebannerimg}
        bgImage={textData.layer1.img}
        textContent={
          <h1>
            {textData.layer1.heading.text1}
            <span>
              {textData.layer1.heading.text2}
            </span>
             {textData.layer1.heading.text3}
			<span>
            {textData.layer1.heading.text4}
			</span>
          </h1>
        }
        breadcrumbs={
			<ol className="breadcrumb">
			<li className="breadcrumb-item"><a href="/">Home </a></li>
			<li className="breadcrumb-item"><a href="/Technologies/Salesforce">Technologies </a></li>
			<li className="breadcrumb-item active" aria-current="page">Full Stack</li>
		</ol>
        }
      />

<div className="container-fluid m-0 caseStudyContent">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <section>
                                <h1>{textData.ourServices.title}</h1>
                                <div className="row introductionsection digitalPortals-left-img-row">
                                    <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
                                        <img
                                            className="AIChatbot-introduction-img"
                                            src={textData.ourServices.img}
                                            alt="overview-img"
                                        />
                                    </div>
                                    <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
                                        <div className="p-0">
                                            <p className='text-20 '>{textData.ourServices.description1}</p>
                                            <p className='text-20 mt-2'>{textData.ourServices.description2}</p>
                                        </div>
                                    </div>
                                    </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

			<div className="alliances d-flex flex-column justify-content-center align-items-center ">
        <h1 className="text-white text-center">
          {textData.layer6.heading.text1}
          <span>{textData.layer6.heading.text2}</span>
          {textData.layer6.heading.text3}
        </h1>
        <ContactUsButton
          text={textData.layer6.button.text}
          link="#ContactForm"
          className="light"
        />
      </div>


			<div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.expertiseAcrossMultipleFullStackTechnologies.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.expertiseAcrossMultipleFullStackTechnologies.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>{textData.expertiseAcrossMultipleFullStackTechnologies.description1}</p>
              </div>
              <div className="pt-2 text-20">
                <p>{textData.expertiseAcrossMultipleFullStackTechnologies.description2}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>
              {textData.javaScriptBasedFullStacks.title}
            </span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>
                  {
                    textData.javaScriptBasedFullStacks
                      .description1
                  }
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.javaScriptBasedFullStacks.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p dangerouslySetInnerHTML={{ __html:  textData.javaScriptBasedFullStacks.description2 }} />
                <p className='mt-2' dangerouslySetInnerHTML={{ __html:  textData.javaScriptBasedFullStacks.description3 }} />
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.javaScriptBasedFullStacks.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

	        <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.pythonBasedFullStacks.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.pythonBasedFullStacks.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.pythonBasedFullStacks.description1 }} />
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.pythonBasedFullStacks.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.pythonBasedFullStacks.description2 }} />
                <p className='mt-2' dangerouslySetInnerHTML={{ __html: textData.pythonBasedFullStacks.description3 }} />
              </div>
            </div>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>
              {textData.ourServicesEndToEndFullStackDevelopment.title}
            </span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>
                  {
                    textData.ourServicesEndToEndFullStackDevelopment
                      .description
                  }
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.ourServicesEndToEndFullStackDevelopment.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.requirementsGatheringAndDocumentation.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.requirementsGatheringAndDocumentation.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.requirementsGatheringAndDocumentation.description1 }} />
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.requirementsGatheringAndDocumentation.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.requirementsGatheringAndDocumentation.description2 }} />
                <p className='mt-2' dangerouslySetInnerHTML={{ __html: textData.requirementsGatheringAndDocumentation.description3 }} />
              </div>
            </div>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>
              {textData.agileSoftwareDevelopmentLifecycle.title}
            </span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p>
                  {
                    textData.agileSoftwareDevelopmentLifecycle
                      .description1
                  }
                </p>
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.agileSoftwareDevelopmentLifecycle.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p dangerouslySetInnerHTML={{ __html:  textData.agileSoftwareDevelopmentLifecycle.description2 }} />
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.agileSoftwareDevelopmentLifecycle.img}
                className="img-fluid mb-3 w-100"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.gitRepositoryManagementAndBranchingStrategy.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.gitRepositoryManagementAndBranchingStrategy.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.gitRepositoryManagementAndBranchingStrategy.description1 }} />
              </div>
              <div className="pt-2 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.gitRepositoryManagementAndBranchingStrategy.description2 }} />
              </div>
            </div>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals bg-color">
        <div className="container">
          <h1 className="mb-5">
            <span>
              {textData.automatedTestingAndQualityAssurance.title}
            </span>
          </h1>
          <div className="row modernPortal-right-img-row">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.automatedTestingAndQualityAssurance.description1 }} />
              </div>
              <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.automatedTestingAndQualityAssurance.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p dangerouslySetInnerHTML={{ __html:  textData.automatedTestingAndQualityAssurance.description2 }} />
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.automatedTestingAndQualityAssurance.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

	  <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-5">
            <span>{textData.devOpsAndDeploymentAutomation.title}</span>
          </h1>
          <div className="row modernPortal-left-img-row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12  d-flex justify-content-center align-items-center">
              <img
                src={textData.devOpsAndDeploymentAutomation.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex flex-column justify-content-center">
              <div className="p-0 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.devOpsAndDeploymentAutomation.description1 }} />
              </div>
			  <div className="pt-2 text-20">
                <ul className="healthcare-list">
                  {textData.devOpsAndDeploymentAutomation.points.map(
                    (point, index) => {
                      return (
                        <li
                          className="healthcare-list-point"
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        />
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="pt-2 text-20">
                <p dangerouslySetInnerHTML={{ __html: textData.devOpsAndDeploymentAutomation.description2 }} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <SuccessStoriesList StoriesList={textData.storiesList} />
	    <div className="container-fluid whyChoose ModernPortals">
        <div className="container">
          <h1>
            <span>{textData.whyEngineersmind.title}</span>
          </h1>
          <p className="text-20 mb-4" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.description1 }} />
          <div className="pt-0 text-20">
            <ul className="whychoose-points">
              {textData.whyEngineersmind.points.map((point, index) => {
                return (
                  <li className="" key={index}>
                    <p dangerouslySetInnerHTML={{ __html: point }}></p>
                  </li>
                );
              })}
            </ul>
          </div>
          <p className="pt-2 text-20" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.description2 }} />
          <p className="pt-2 text-20" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.description3 }} />
          <p className="pt-2 text-20" dangerouslySetInnerHTML={{ __html: textData.whyEngineersmind.description4 }} />
        </div>
      </div>
		</div>
	)
}

export default Stack;